import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import Connect from "./Connect";
// import { Instagram } from "lucide-react";

const FeatureArticle = () => {
  const [blogs, setBlogs] = useState([]);
  const [expandedId, setExpandedId] = useState(null);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/blogs`);
        setBlogs(res.data.reverse()); // latest first
      } catch (error) {
        console.error("Error fetching blogs:", error);
      }
    };
    fetchBlogs();
  }, []);

  return (
    <>
      <div className="bg-[#0F172B] p-5 md:p-15 text-white">
        {/* Section Title */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          className="text-center mb-10"
        >
          <motion.button
            className="bg-[#432DD7] w-[252px] h-[60px] text-white font-[Nunito] rounded-full"
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.95 }}
          >
            Feature Articles
          </motion.button>
          <h2 className="md:text-[40px] text-[22px] font-[700] mt-4">
            Featured Projects highlighting excellence
          </h2>
          <h2 className="font-[Allison] md:text-[40px] text-[22px] font-[400]">
            in design, development, and user experience.
          </h2>
        </motion.div>

        {/* Blog Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
  {blogs.map((blog) => (
    <motion.div
      key={blog.id}
      className="bg-[#1F2937] rounded-xl overflow-hidden shadow-lg"
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
    >
      <img
        src={`${process.env.REACT_APP_API_URL}/uploads/${blog.image}`}
        alt={blog.title}
        className="w-full h-60 object-cover"
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = "/fallback.jpg";
        }}
      />
      <div className="p-4">
        <div className="flex gap-5 text-sm mb-3 text-pink-400 font-[Nunito]">
          <span>📅 {blog.date}</span>
          <span>👤 {blog.username}</span>
        </div>
        <h3 className="text-[#FF4FE4] font-bold text-xl">{blog.title}</h3>
        <p className="text-[16px] whitespace-pre-line mt-2 font-[Nunito]">
          {expandedId === blog.id ? blog.content : `${blog.content.slice(0, 200)}...`}
        </p>
        <button
          className="text-[#FF4FE4] mt-3 bg-[#FFFFFF33] px-4 py-2 rounded-full"
          onClick={() => setExpandedId(expandedId === blog.id ? null : blog.id)}
        >
          {expandedId === blog.id ? "Show Less ▲" : "Read More ↔"}
        </button>
      </div>
    </motion.div>
  ))}
</div>
      </div>

      <Connect />
    </>
  );
};

export default FeatureArticle;
